document.addEventListener('DOMContentLoaded', function () {
  const accordionContainers = document.querySelectorAll('.accordion-container');
  const pageURL = window.location.href;
  const subscribedDiv = document.querySelector('.news-letter-already-subscribed');
  const subscribeErrorCheck = document.querySelector('#ContactFooter-error');

  accordionContainers.forEach((container) => {
    container.addEventListener('click', function () {
      const parent = this.getAttribute('data-parent');
      const contentElements = document.querySelectorAll(`[data-content="${parent}"]`);
      const arrowDown = this.querySelector('.arrow-down-foooter');

      // Toggle rotation class on arrow-down-foooter
      arrowDown.classList.toggle('rotate-down');

      // Toggle bmd:tw-hidden class on content elements
      contentElements.forEach((element) => {
        element.classList.toggle('mdg:tw-hidden');
      });
    });
  });

  if (!subscribeErrorCheck && pageURL.includes('?contact%5Btags%5D=newsletter&form_type=customer')) {
    subscribedDiv.classList.remove('tw-hidden');
  }
});